import Layout from '../layout/components/mainbox.vue'
import store from '@/store/index.js'
import Vue from 'vue'
import recom from '../layout/components/recom.vue'

// 转component字段的字符串为import
export function changeroute(routers) {
	let routerTree = []
	ensureWechatTemplateRoutes(routers)
	routerTree = assembleroute(routers,1).routerTree
	sessionStorage.setItem('routestext',JSON.stringify(routerTree))
	//已完成组装 改变vuex状态
	store.commit('routestatus', 1)
	return routerTree
}

function ensureWechatTemplateRoutes(routers = []) {
	routers.forEach((item) => {
		if (item._child && item._child.length > 0) {
			ensureWechatTemplateRoutes(item._child)
		}
	})

	const baseIndex = routers.findIndex((item) => item.path == '/common/channel/wx/baseconfig')
	if (baseIndex == -1) return

	const baseRoute = routers[baseIndex]
	const defaultMeta = {
		icon: baseRoute.icon || '',
		layout: '1',
		router_name: baseRoute.router_name || 'wechatSubscribe',
		app_level: baseRoute.app_level == undefined ? 0 : baseRoute.app_level,
	}
	const templateRoutes = [
		{
			component: 'apps/common/channel/wx/public.vue',
			name: '公共模板',
			path: '/common/channel/wx/public',
			vue_name: 'wechatSubscribePublic',
		},
		{
			component: 'apps/common/channel/wx/private.vue',
			name: '私有模板',
			path: '/common/channel/wx/private',
			vue_name: 'wechatSubscribePrivate',
		},
	]

	templateRoutes.reverse().forEach((route) => {
		if (routers.some((item) => item.path == route.path)) return
		routers.splice(baseIndex + 1, 0, {
			...defaultMeta,
			...route,
		})
	})
}

//递归组装路由
function assembleroute (routers,type){
	let routerTree = []
	let plugin = []
	
	routers.forEach(item=>{
		let obj = {
			path: item.path,
			name: item.vue_name,
			meta:{
				title:item.name,
				layout:item.layout,
				router_name:item.router_name,
				icon:item.icon,
				notright:item.notright,
				keep:item.keep_alive,
				// keepAlive:true,
				level:type,
			}
		}
		
		if(item.props){
			obj.meta.props = item.props
		}
		
		if(item.component == 'Layout'){
			Vue.set(obj, 'component', recom)
		}else{
			Vue.set(obj, 'component', (resolve) => require([`@/views/${item.component}`],resolve))
		}
				
		if(item._child&&item._child.length>0){
			obj.children = assembleroute(item._child,type+1).routerTree
			obj.plugin = assembleroute(item._child,type+1).plugin
		}
		
		if(item.app_level==0||item.app_level==2){
			routerTree.push(obj)
		}else{
			plugin.push(obj)
		}
	})

	return {
		'routerTree':routerTree,
		'plugin':plugin
	} 
}
